export default __webpack_public_path__ + "static/media/Pending.bafdce76.svg";